export const ADMIN_USER_PATH = '/admin/user';
export const ADMIN_USER_SETTINGS_PATH = '/admin/user/settings';
export const ADMIN_USER_SETTINGS_PROFILE_PATH = '/admin/user/settings/profile';
export const ADMIN_USER_SETTINGS_CONTACT_PATH = '/admin/user/settings/contact';
export const ADMIN_USER_SETTINGS_EXPERIENCE_PATH = '/admin/user/settings/experience';
export const ADMIN_USER_SETTINGS_EXPERIENCE_ADD_PATH = '/admin/user/settings/experience/add';
export const ADMIN_USER_SETTINGS_EXPERIENCE_DETAIL_PATH = '/admin/user/settings/experience/:experienceId';
export const ADMIN_USER_SETTINGS_EXPERIENCE_EDIT_PATH = '/admin/user/settings/experience/:experienceId/edit';
export const ADMIN_USER_SETTINGS_EDUCATION_PATH = '/admin/user/settings/education';
export const ADMIN_USER_SETTINGS_EDUCATION_ADD_PATH = '/admin/user/settings/education/add';
export const ADMIN_USER_SETTINGS_EDUCATION_DETAIL_PATH = '/admin/user/settings/education/:educationId';
export const ADMIN_USER_SETTINGS_EDUCATION_EDIT_PATH = '/admin/user/settings/education/:educationId/edit';
export const ADMIN_USER_SETTINGS_ACCOUNT_PATH = '/admin/user/settings/account';
export const ADMIN_USER_SETTINGS_NOTIFICATIONS_PATH = '/admin/user/settings/notifications';
export const ADMIN_USER_SETTINGS_PASSWORD_PATH = '/admin/user/settings/password';
